export default __webpack_public_path__ + "static/media/439.2c142e56.jpg";